<template>
  <div class="regulatory">
    <Header></Header>
    <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
    <label class="verticalLabel right reportTitle">Regulatory</label> -->
    <div class="content-wrapper">
      <main-banner :scroll-settings="scrollSettings" :main_banner="this.regulatory.main_banner" />

      <organizationalResponse :organize="this.regulatory.organizationalResponse" />
      <!-- Key Facts -->
      <Facts :facts="this.regulatory.facts" />
      <!-- Key Facts -->
      <!-- Spectrum -->
      <spectrumLicense
        :slider-settings="sliderSettingsmain"
        :scroll-settings="scrollSettings"
        :spectrum="this.regulatory.spectrum"
      />
      <!--Spectrum -->

      <!-- Customer Affairs -->
      <customerAffairs :customer_data="this.regulatory.customer" :scroll-settings="scrollSettings" />
      <!-- Customer Affairs -->

      <FiveG
        :slider-settings="sliderSettingsmain"
        :scroll-settings="scrollSettings"
        :fiveG="this.regulatory.fiveG"
      />
      <B2B :b2b="this.regulatory.b2b"  :scroll-settings="scrollSettings" />
      <IOT :IOT="this.regulatory.iot" />
      <IOTSlide
        :slider-settings="sliderSettingsmain"
        :scroll-settings="scrollSettings"
        :IOTSlide="this.regulatory.IOTSlide"
      />
      <!-- digital service -->
      <digitalService :digital_service="this.regulatory.digital_service" :scroll-settings="scrollSettings" />
      <!-- digital service -->

      <digitalSlide
        :slider-settings="sliderSettingsmain"
        :scroll-settings="scrollSettings"
        :digital_slide="this.regulatory.digital_slide"
      />
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import VueSlickCarousel from "vue-slick-carousel";
import "@/assets/sccs/regulatory.scss";
import regulatory from "@/components/regulatory/json/regulatory";
import util from '@/mixin/util.js';
export default {
    mixins: [util],
    name: "regulatory",
    components: {
        VueSlickCarousel,
        organizationalResponse: () =>
        import("@/components/regulatory/organizationalResponse"),
        Facts: () => import("@/components/regulatory/keyfacts"),
        spectrumLicense: () => import("@/components/regulatory/spectrumLicense"),
        customerAffairs: () => import("@/components/regulatory/customerAffairs"),
        FiveG: () => import("@/components/regulatory/FiveG"),
        B2B: () => import("@/components/regulatory/B2B"),
        IOT: () => import("@/components/regulatory/IOT"),
        IOTSlide: () => import("@/components/regulatory/IOTSlide"),
        digitalService: () => import("@/components/regulatory/digitalService"),
        MainBanner: () => import("@/components/regulatory/Main-Banner"),
        digitalSlide: () => import("@/components/regulatory/digitalSlide"),
    },
    data() {
        return {
            regulatory:regulatory,
            scrollSettings: {
                maxHeight: 100,
            },
            sliderSettingsmain: {
            slidesToShow: 1,
            slideToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            cssEase: "ease-in",
            speed: 1000,
            },
        };
    },
    created(){
        if(this.$i18n.locale=="en"){
            this.regulatory = this.regulatory.en;
        }
        else{
            this.regulatory = this.regulatory.ar;
            
        }
    }
};
</script>
